module.exports = __webpack_public_path__ + "img/news.a6c0bcf6.svg";